import { CircularProgress, Stack, Typography } from '@mui/material';
import { Image } from 'app/components';
import React from 'react';

const Loader = () => {
  return (
    <Stack
      direction='column'
      alignItems='center'
      justifyContent='center'
      sx={(theme) => ({
        height: '100vh',
        padding: theme.spacing(0),
        color: theme.palette.primary.main,
        img: {
          display: 'none',
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        },
        h6: {
          zIndex: '1',
          display: 'none',
          color: theme.palette.common.white,
          fontSize: '14px',
          marginTop: theme.spacing(2),
        },
      })}>
      <Image name='authentication-layout.jpg' alt='authentication-layout' />
      <CircularProgress size={24} color='inherit' />
      <Typography variant='h6'>Подождите, идёт загрузка компонентов...</Typography>
    </Stack>
  );
};

export default Loader;
